import { Money } from '@shared/types/product/Money';
import { Tier } from '@shared/types/product/Tier';

// EWM-523 — resolve the per-unit price for a given order quantity against a
// SKU's bulk-pricing tiers. Mirrors commercetools' scaled-price semantics
// (the same resolution CT applies server-side and that the checkout page
// reflects via `lineItem.price`): the applicable price is the tier with the
// largest `minimumQuantity <= quantity`; below the first tier — or when there
// are no tiers — the base price applies.
//
// `base` is the qty-1 Standalone Price value resolved by the BFF price engine
// (EWM-525); `priceBreaks` are that same channel's `tiers[]`. Tiers are not
// assumed to be pre-sorted.
export const resolveTierUnitPrice = (
  base: Money | undefined,
  priceBreaks: Tier[] | undefined,
  quantity: number,
): Money | undefined => {
  const qualifying = (priceBreaks ?? [])
    .filter((tier) => quantity >= tier.minimumQuantity)
    .sort((a, b) => b.minimumQuantity - a.minimumQuantity);

  return qualifying[0]?.value ?? base;
};
